import { default as limbo } from './limbo'
import { default as dice } from './dice'
import { default as dragontower } from './dragontower'
import { default as hilo } from './hilo'
import { default as keno } from './keno/index'
import { default as mines } from './mines/index'
import { default as diamonds } from './diamonds'
import { default as scarab } from './scarab'
import { default as tomeoflife } from './tomeoflife'
import { default as samurai } from './samurai'
import { default as packs } from './packs'
import { default as plinko } from './plinko'
import { default as wheel } from './wheel'
import { default as videopoker, VideoPokerBet, VideoPokerStrategies } from './videopoker'

export { VideoPokerBet, VideoPokerStrategies }
export default { limbo, dice, dragontower, diamonds,hilo,  videopoker, keno, mines, scarab, packs, plinko, wheel, samurai, tomeoflife }